import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';


const create = async (data: any): Promise<any> => {
    
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.post('./chamados', data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao criar menssagem.');
    } catch (error) {
        console.error(error);
        return new Error((error as { message: string }).message || 'Erro ao criar menssagem.');
    }
};

export const SuportServices = {
    create
};